import type { CompanyType } from "@services/licensing/types";

export const VENDOR_LICENSE_REQUEST_FIELDS = {
  COMPANY_NAME: "companyName",
  COMPANY_NAME_ARABIC: "companyNameArabic",
  COMPANY_TYPES: "companyTypes",
  COMPANY_ADDRESS: "companyAddress",
  TELEPHONE_NUMBER: "telephoneNumber",
  MOBILE_NUMBER: "mobileNumber",
  FAX_NUMBER: "faxNumber",
  COMPANY_EMAIL: "companyEmail",
  APPLICANT_EMAIL: "applicantEmail",
  APPLICANT_NAME: "applicantName",
  APPLICANT_POSITION: "applicantPosition",
  NATURE_OF_BUSINESS_IN_POF: "natureOfBusinessInPof",
  NUMBER_OF_EMPLOYEES: "numberOfEmployees",
  NUMBER_OF_VEHICLES: "numberOfVehicles",
  TRADING_LICENSE_NUMBER: "tradingLicenseNumber",
  TRADING_LICENSE_VALIDITY_DATE: "tradingLicenseValidityDate",
  TRADE_LICENSE_ISSUING_AUTHORITY: "tradeLicenseIssuingAuthority",
  PURPOSE_OF_REQUEST: "purposeOfRequest",
  TRADE_LICENSE_DOCUMENT_URL: "tradeLicenseDocumentUrl",
  COMPANY_INCORPORATION_DOCUMENT_URL: "companyIncorporationDocumentUrl",
} as const;

export const formatCompanyTypes = (
  value: string | CompanyType | ReadonlyArray<string | CompanyType> | null | undefined,
): string | undefined => {
  const values = Array.isArray(value) ? value : value == null ? [] : [value];

  const formattedValue = values
    .flatMap((companyType) =>
      typeof companyType === "string"
        ? companyType.split(",")
        : companyType.companyTypeDesc || companyType.companyTypeCode,
    )
    .map((companyType) => companyType.trim())
    .filter(Boolean)
    .join(", ");

  return formattedValue || undefined;
};

export const tradeLicenseIssuingAuthorities = [
  { label: "Abu Dhabi", value: "ABU_DHABI" },
  { label: "Ajman", value: "AJMAN" },
  { label: "Dubai", value: "DUBAI" },
  { label: "Fujairah", value: "FUJAIRAH" },
  { label: "Ras Al Khaimah", value: "RAS_AL_KHAIMAH" },
  { label: "Sharjah", value: "SHARJAH" },
  { label: "Umm Al Quwain", value: "UMM_AL_QUWAIN" },
] as const;

export const VENDOR_COMPANY_TYPE_CODE = "is_vendor";
